module.exports = __webpack_public_path__ + "img/76300.76480e6b.svg";